export default __webpack_public_path__ + "static/media/noteAndNotify.cb0c4e7d.svg";